import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '見積り精度のバラつきと業務複雑化に悩むアート引越センターのDX推進施策として、3Dスキャナーと専用AIモデルをゼロから開発。家財の物量を自動積算するスマホアプリ「ぐるっとAI見積り」を実現し、申し込み率が他チャネルを上回る成果を達成した物流DX開発事例です。'

const ogpImg = `${SITE_URL}/images/img/cases/gurutto-ai/ogp_gurutto-ai.png`

export const guruttoAiPageMeta: PageMeta = {
  title: 'アート引越センター AI自動見積りアプリ開発｜3Dスキャン×専用AIモデルの事例 | Aitria（アイトリア）',
  description,
  keyword: 'AI モバイルアプリ UX/UI DX推進',
  image: ogpImg,
  url: `${SITE_URL}/cases/gurutto-ai/`,
}

export const guruttoAiSchema = buildCaseStudySchema({
  slug: 'gurutto-ai',
  pageTitle: guruttoAiPageMeta.title,
  description: guruttoAiPageMeta.description,
  headline: 'AI搭載アプリ開発で申し込み率改善、引越業務も効率化',
  alternativeHeadline: 'アート引越センター株式会社',
  primaryImage: ogpImg,
  images: [ogpImg, `${SITE_URL}/images/img/cases/gurutto-ai/gurutto-ai.webp`],
  clientName: 'アート引越センター株式会社',
  breadcrumbLabel: 'AI搭載アプリ開発で申し込み率改善、引越業務も効率化',
})
